import { Grid, Link, Button, Box, CircularProgress } from "@mui/material"
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import Header from "../../layout/header"
import Preview from "../template/previews/Preview"
import Preview1 from "../template/previews/Preview1"
import Preview2 from "../template/previews/Preview2"
import Preview3 from "../template/previews/Preview3"
import Preview4 from "../template/previews/Preview4"
import Preview5 from "../template/previews/Preview5"
import Preview6 from "../template/previews/Preview6"
import Action from "./Action"
import { useRef, useState, useMemo } from "react"
import RichTextEditor from 'react-rte';
import jsPDF from "jspdf"
import html2canvas from "html2canvas"
import { useNavigate } from "react-router-dom";
const Create = () =>{
    const navigate = useNavigate();
    const educationFields = {'school_name': '', 'school_location':'','degree':'','field_of_study':'','start_date':[''],'end_date':['']}
    const experienceFields =  {'job_title': '', 'employer':'','start_date':['',''],'end_date':['',''],'description':RichTextEditor.createEmptyValue()}
    const skillsFileds =   {'skill':'', 'rating':0}
    const otherFields = {'title':'', 'content':RichTextEditor.createEmptyValue()}
    const initialState = {
        'f_name': '',
        'l_name': '',
        'email': '',
        'phone': '',
        'city':'',
        'state':'',
        'designation': '',
        'objective': '',
        'education': [],
        'experience':[],
        'skills':[],
        'other':[]
    }
    const [fieldValues, setFieldValues] = useState(localStorage.getItem('fieldValues') ? JSON.parse(localStorage.getItem('fieldValues')) : initialState)
    const [downloadInProgress, setDownloadInProgress] = useState(false)
    const selectedTemplate = localStorage.getItem('template')
    const selectedColor = JSON.parse(localStorage.getItem('color')) ||  ['#1B263B', '#D6E0F5','#FFF']
    const previewRef = useRef()
    let [sections, setSections] = useState(['Contact', 'Objective', 'Education','Experience', 'Skills', 'Other'])
    const templates = useMemo(() => ({
        1: Preview,
        2: Preview1,
        3: Preview2,
        4: Preview3,
        5: Preview4,
        6: Preview5,
        7: Preview6
      }), []);
    const SelectedPreview = templates[selectedTemplate] || null;

    const handleOnChange = (name, val) =>{
        setFieldValues({...fieldValues, [name]: val})
    }

    const handleIndexedOnChange = (module, index, name, val) =>{
        const tempFieldValues = {...fieldValues}
        tempFieldValues[module][index][name] = val
        setFieldValues(tempFieldValues)
    }
    const handleDateField = (module, index, name, val, key) =>{
        const tempFieldValues = {...fieldValues}
        tempFieldValues[module][index][name][key === 'year' ? 0 : 1 ] = val
        setFieldValues(tempFieldValues)
    }
    
    const handleAddNew = (module) =>{
        const tempFieldValues = {...fieldValues}
        tempFieldValues[module].push(module === 'education' ? educationFields : module === 'experience' ? experienceFields : 'other' ? otherFields : skillsFileds)
        setFieldValues(tempFieldValues)
    }

    const handleDelete = (module, index) => {
        const tempFieldValues = {...fieldValues}
        tempFieldValues[module].splice(index, 1)
        setFieldValues(tempFieldValues)
    }

    const handleChangeTemplate = () => {
        localStorage.setItem("fieldValues", JSON.stringify(fieldValues))
        navigate('/template')
    }
    const handleSave = () => {
        let tempSaved = localStorage.getItem('savedTemplates') ? JSON.parse(localStorage.getItem('savedTemplates')) : []
        tempSaved.push({'template': selectedTemplate, 'color': selectedColor, 'values': fieldValues })
        localStorage.setItem("savedTemplates", JSON.stringify(tempSaved))
        navigate('/')
    }

    const handleDownload = () => {
        setDownloadInProgress(true)
        html2canvas(previewRef.current, {
            scale: 3, // Higher scale for better clarity (slow processing if it's high)
          }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4', true); 
            const PAGE_WIDTH = 210; // A4 width in mm
            const PAGE_HEIGHT = 297; // A4 height in mm
    
            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;
    
            const imgHeight = Math.floor((PAGE_WIDTH / canvasWidth) * canvasHeight);
            console.log(canvasHeight, imgHeight);
    
            let position = 0;
    
            if (imgHeight > PAGE_HEIGHT) {
              let heightUnprinted = imgHeight;
    
              while (heightUnprinted > 0) {
                pdf.addImage(imgData, "PNG", 0, position, PAGE_WIDTH, imgHeight);
                heightUnprinted -= PAGE_HEIGHT;
                position -= PAGE_HEIGHT;
                if (heightUnprinted > 0) pdf.addPage(); // add another page if there's more contents to print
              }
            } else {
              pdf.addImage(imgData, "PNG", 0, 0, PAGE_WIDTH, PAGE_HEIGHT);
            }
    
            pdf.save("Resume.pdf");
          })
          .catch((err) => console.log(err))
          .finally(() => setDownloadInProgress(false));
      };

    return <DndProvider backend={HTML5Backend}>
        <Header />
        <Grid container spacing={2} pt={5}>
            <Grid item xs={7}>
                <Action fieldValues={fieldValues} handleOnChange={handleOnChange} handleAddNew={handleAddNew} handleDelete={handleDelete} handleIndexedOnChange={handleIndexedOnChange} handleDateField={handleDateField} sections={sections} setSections={setSections}/>
            </Grid>
            <Grid item xs={5} p={5}>
                <Grid item py={2} sx={{display: 'flex', flexDirection: 'row-reverse'}} gap={3}>
                    <Link href={'/'}><Button variant="contained">Close</Button></Link>
                    <Button variant="contained" onClick={()=>handleSave()}>Save</Button>
                    <Button variant="contained" onClick={()=>handleChangeTemplate()}>Change Template</Button>
                    <Button variant="contained" onClick={handleDownload} disabled={downloadInProgress} startIcon={ downloadInProgress && <CircularProgress sx={{color:"white"}} size={20} thickness={5} disableShrink/>}>{downloadInProgress ? "Downloading" : "Download" }</Button>
                </Grid>
                {SelectedPreview && <SelectedPreview fieldValues={fieldValues} selectedColor={selectedColor} fullHeight={true} sections={sections}/> }
                {/* for printing */}
                <Box sx={{width: '21cm', minHeight: '29.7cm', display:'flex', position:'absolute', top: -9999, left:0, zIndex:-9999, }} ref={previewRef}>
                    {SelectedPreview && <SelectedPreview fieldValues={fieldValues} selectedColor={selectedColor} sections={sections}/> }
                </Box>
            </Grid>    
        </Grid>
    </DndProvider>
}
export default Create